<template>
  <a
    class="btn user-btn j-header-logout-btn"
    :href="'javascript:void(0)'"
    v-show="isLogin"
    :class="lang"
  >
    <a :href="'javascript:;'" class="name blue logout" @click="logout">
      [{{ letter.logout }}]
    </a>
    <span class="name" v-html="userName"></span>
  </a>
</template>

<script>
import { RESET_USER_INFO } from '../../store/login';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'headerAccountGlobal',
  computed: {
    userName() {
      return this.$store.state.login.userName;
    },

    ...mapGetters(['isLogin', 'lang', 'letter']),
  },
  methods: {
    ...mapActions(['logout']),
  },
};
</script>
